import { TCoverageSideEffectsType } from '@sureapp/platform-sdk';

import { TConfig, TConfigInput } from '@@/auto/interfaces';

import { AUTO_DISCOUNTS } from '../../autoDiscounts';

const tenant = process.env.REACT_APP_TENANT;

function ToggleTNConfig(): DeepPartial<TConfigInput> {
  return {
    autoDiscounts: [
      ...(tenant === 'toggle' ? [AUTO_DISCOUNTS.tnDirectDiscount] : []),
      AUTO_DISCOUNTS.matureDriver55,
      AUTO_DISCOUNTS.safeDriving,
      AUTO_DISCOUNTS.multiCar,
      AUTO_DISCOUNTS.multiPolicy,
      AUTO_DISCOUNTS.homeowner,
      AUTO_DISCOUNTS.goodStudent,
      AUTO_DISCOUNTS.distantStudent,
      AUTO_DISCOUNTS.teenDriver,
    ],
    auto: (auto: TConfig['auto']) => ({
      ...auto,
      addOns: {
        ...auto.addOns,
        options: {
          ...auto.addOns.options,
          oem_parts: {
            ...auto.addOns.options.oem_parts,
            copy: {
              ...auto.addOns.options.oem_parts?.copy,
              modalContent: `This is an optional coverage that pays for original factory equipment replacement parts in the event that your vehicle is damaged in a covered loss. Non original factory equipment replacement parts shall not be used on current year or immediate prior year model cars without your permission.`,
            },
          },
        },
      },
    }),
    coverage: (coverage: TConfig['coverage']) => ({
      ...coverage,
      uninsuredMotoristPropertyDamage: {
        ...coverage.uninsuredMotoristPropertyDamage,
        description: `Your bumper sticker might say 'don't hit me if you're uninsured or underinsured' but it isn't actually protecting you against that. Don't worry, this coverage can.`,
        modalContent: `Uninsured Motorist Property Damage (UMPD) pays, up to the limits chosen, the amount you are legally entitled to recover for physical damages to your insured car sustained in an accident caused by a driver who is not insured or doesn't have enough insurance to cover the damage. Note: Payments for this coverage are subject to a $200 deductible.`,
      },
      uninsuredMotoristBodilyInjury: {
        ...coverage.uninsuredMotoristBodilyInjury,
        description: `That pain in your neck is not just from the accident - it's also from finding out that the person who hit you has either no insurance or not enough. This coverage can help.`,
        modalContent: `Uninsured Motorist Bodily Injury (UMBI) pays the amount you are legally entitled to recover for damages from bodily injury, up to the limit of liability, when an insured person on your policy is hit by an uninsured driver, underinsured driver, or an unidentified (e.g. hit-and-run) driver.`,
      },
    }),
    coverageTextAlerts: (
      coverageTextAlerts: TConfig['coverageTextAlerts']
    ) => ({
      ...coverageTextAlerts,
      UMBI_UPDATE: ({ isRemoved, causeName }: TCoverageSideEffectsType) =>
        isRemoved
          ? ''
          : `Your Uninsured Motorist Bodily Injury limits may have changed based on the changes you've made to your ${causeName} coverage.`,
      UIMBI_UPDATE: ({ isRemoved, causeName }: TCoverageSideEffectsType) =>
        isRemoved
          ? ''
          : `Your Underinsured Motorist Bodily Injury limits may have changed based on the changes you've made to your ${causeName} coverage.`,
    }),
    initialCoverageValues: (
      initialCoverageValues: TConfig['initialCoverageValues']
    ) => ({
      ...initialCoverageValues,
      gap: 'false',
      temporary_ride: 'null',
      side_hustle: 'false',
    }),
    matureDriver: (matureDriver: TConfig['matureDriver']) => ({
      ...matureDriver,
      getSubjectText: null,
      label:
        'Has this person completed a mature driver motor vehicle accident prevention course?',
    }),
    vehicleSideEffectMessages: (
      vehicleSideEffectMessages: TConfig['vehicleSideEffectMessages']
    ) => ({
      ...vehicleSideEffectMessages,
      oem_parts:
        'This coverage is only available if Comprehensive and Collision are selected and the model year is between two (2) and ten (10) years old.',
    }),
    visibleCoverages: (visibleCoverages: TConfig['visibleCoverages']) => ({
      ...visibleCoverages,
      protectionCoverages: [
        ...visibleCoverages.protectionCoverages.filter(
          ({ key }) =>
            ![
              'pet_passenger',
              'uninsured_motorist_property_damage_limit',
            ].includes(key)
        ),
        {
          label: 'Uninsured Motorist Property Damage',
          key: 'uninsured_motorist_property_damage_limit',
        },
        visibleCoverages.protectionCoverages.find(
          ({ key }) => key === 'pet_passenger'
        ),
      ],
    }),
  };
}
export default ToggleTNConfig;
